module.exports = __webpack_public_path__ + "media/dm-approve.0e80b218.svg";